/**
 * Layout: FAQ
 * Slug: faq
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.faq-layout');

	layouts.forEach((layout) => {
		
	});
});
